<template>
  <div class="pass-reset-box">
    <h1 class="">パスワード再設定</h1>
    <div v-if="mode == 1">
      <h2>入力したメールアドレスに<br />パスワード変更の案内メールをお送りします。</h2>
      <div class="passreset">
        <form method="post" @submit.prevent="send" autocomplete="on">
          <label class="label">メールアドレス</label><span class="help is-danger" v-html="e_msg_u_id"></span>
          <p class="control"><input type="text" name="user_id" autocomplete="on" placeholder="メールアドレス" class="input" v-model="user_id"></p>
          <input class="button" type="submit" value="送信">
        </form>
      </div>
    </div>
    <div v-if="mode == 2">
      <h2>入力したメールアドレスに<br />パスワード変更の案内メールをお送りしました。<br /><br />メールをご確認ください。</h2>
    </div>
    <div class="back">
      <a @click="cancel">← ログインページに戻る</a>
    </div>
    <div class="footer">
      Produced by
    </div>
  </div>
</template>

<script>
export default {
  name: 'PassReset',

  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      e_msg_u_id: '',
      user_id: '',
      mode: 1,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    send () {
      let eFlg = false;
      if (!this.user_id) {
        this.e_msg_u_id = 'メールアドレスを入力してください';
        eFlg = true;
      } else {
        this.e_msg_u_id = '';
      }

      if (eFlg === false) {
        let ld = new this.$loader(this);
        ld._data_set({mail: this.user_id});
        ld._post_cb_f = this.send_cb;
        ld._load_start('/user/forgot_password.php');
      }
    },
    send_cb (data) {
      if (data.res === 1) {
        this.mode = 2;
      } else if (data.res === this.$DF.RES_MAIL_ERR) {
        this.$alert('alert', '登録されていないメールアドレスです。');
      } else {
        this.$alert('alert', `エラーコード：${data.res}`);
      }
    },

    pass_reset () {
      this.$router.push({name: 'uPassReset', params: {}});
    },
    cancel () {
      this.$router.push({name: 'uLogin', params: {}});
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.pass-reset-box {
  text-align: center;
  padding-top: 65px;
  h1 {
    color: #1b2010;
    font-size: 28px;
    letter-spacing: 2px;
  }
  h2 {
    font-size: 16px;
    font-weight: 100;
    color: #5b5845;
    margin: 34px 0 20px 0;
  }
  input {
    ime-mode: inactive;
    height: 48px;
    font-size: 18px;
  }

  .passreset {
    position: relative;
    width: 400px;
    margin: 10px auto;
  }

  .control {
    margin-bottom: 17px;
  }

  .label {
    text-align: left;
    float: left;
    border-left: 6px solid #df274c;
    color: #5b5942;
    padding-left: 8px;
    margin-bottom: 5px;
  }

  .button {
    margin-top: 25px;
    width: 100%;
    height: 56px;
    color: #fefefe;
    border: initial;
    border-radius: 5px;
    font-size: 16px;
  }

  .help {
    color: #ff2626;
    font-size: 13px;
    line-height: 1.7;
  }
  .title-header {

  }
  .footer {
    background-image: url('../../assets/order_logo.svg');
    background-repeat: no-repeat;
    background-position: right;
    -ms-background-position-x: 55px;

    width: 256px;
    margin: 70px auto;
    text-align: left;
    height: 40px;
    line-height: 40px;
  }
  .back {
    margin-top: 30px;
    a {
      color: #da7d78;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  @media (max-width: 767px) {
    padding-top: 25px;
    .passreset {
      width: calc(100vw - 110px);
      padding: 18px 15px 22px 15px;
    }
  }
}
</style>
